import { render, staticRenderFns } from "./RandomJokes.vue?vue&type=template&id=b041cc78&scoped=true&"
import script from "./RandomJokes.vue?vue&type=script&lang=js&"
export * from "./RandomJokes.vue?vue&type=script&lang=js&"
import style0 from "./RandomJokes.vue?vue&type=style&index=0&id=b041cc78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b041cc78",
  null
  
)

export default component.exports